<section class="content">
    <div class="container-fluid">
        <h1>
            Time
            <small></small>
        </h1>
        <div class="box">
            <div class="box-header row">
                <div class="col-md-9 col-sm-12">
                    <h3 class="box-title">All Timing</h3>
                </div>
            </div>
            <div class="box-body table-responsive">
                <table id="example1" class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Sl.No</th>
                            <th>Gate Event Name</th>
                            <th>Gate Event Short Name</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="let item of gateList  | filter:searchInput | paginate: {  itemsPerPage: limit, currentPage: page, totalItems: count } let i = index">
                            <td>{{ limit*(page-1)+(i+1) }}.</td>
                            <td>{{ item.gate_event_name }}</td>
                            <td>{{ item.gate_event_short_code}}</td>
                            <td>{{ item.from_time}}</td>
                            <td>{{ item.to_time}}</td>
                            <td> <button type="button" class="btn btn-sm btn-default mr-2 command-edit"
                                    (click)="openModal(item)">
                                    <em class="fa fa-edit fa-fw"></em>
                                </button></td>
                        </tr>
                    </tbody>
                </table>
                <div class="paginate">
                    <pagination-controls class="my-pagination"
                        (pageChange)="paginate(page = $event)"></pagination-controls>
                </div>
            </div>
        </div>
    </div>
</section>